import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ObservableDocumentSchema = withDefaults({
  type: 'observable-document',
  objectExtensions: ['observable-document'],
  traits: ['digital-asset'],
  fields: [
    {
      kind: 'attribute',
      name: 'batch',
    },
    {
      kind: 'attribute',
      name: 'via',
    },
    {
      kind: 'attribute',
      name: 'contentType',
    },
    {
      kind: 'attribute',
      name: 'provider',
    },
    {
      kind: 'attribute',
      name: 'extractedContent',
    },
    {
      kind: 'attribute',
      name: 'structuredContent',
    },
    {
      kind: 'attribute',
      name: 'providedAt',
    },
    {
      kind: 'attribute',
      name: 'extractionState',
    },
    {
      kind: 'attribute',
      name: 'subsistenceState',
    },
    {
      kind: 'attribute',
      name: 'reflectionState',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'belongsTo',
      name: 'observableAsset',
      type: 'observable-asset',
      options: {
        async: false,
        inverse: 'observableDocument',
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: 'observableDocuments',
      },
    },
    {
      kind: 'belongsTo',
      name: 'financialInstitution',
      type: 'financial-institution',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'accountTransactions',
      type: 'account-transaction',
      options: {
        async: false,
        inverse: 'observableDocument',
      },
    },
    {
      kind: 'hasMany',
      name: 'observableDocumentLogs',
      type: 'observable-document-log',
      options: {
        async: false,
        inverse: 'observableDocument',
      },
    },
    {
      kind: 'hasMany',
      name: 'observations',
      type: 'observation',
      options: {
        async: false,
        inverse: 'observableDocuments',
      },
    },
    {
      kind: 'hasMany',
      name: 'observationDocuments',
      type: 'observation-document',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'accounts',
      type: 'account',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'loans',
      type: 'loan',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default ObservableDocumentSchema;
